import { Box, Heading } from '@chakra-ui/react';
import { Prose } from '@/components/ui/prose';

interface Props {
  block: {
    type: number;
    label: string;
  };
  content: any;
  hideLabel?: boolean;
}

export default function LongTextBlock({ block, content, hideLabel = false }: Props) {
  return (
    <Box>
      {!hideLabel && (
        <Heading as={'h3'} fontSize={'xl'} mb={2}>
          {block.label}
        </Heading>
      )}
      <Box pl={hideLabel ? 0 : 2}>
        <Prose size='md'>
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </Prose>
      </Box>
    </Box>
  );
}
